import React, { useState } from 'react';
import styled from 'styled-components';
import Panel from './Panel';
import PeriodSelector from './PeriodSelector';
import Pagination from './Pagination';
import useMonitoringData from '../hooks/useMonitoring';
import { fetchSignupHistory } from '../api/monitoringApi';

const Table = styled.table`width: 100%; border-collapse: collapse; font-size: 13px;`;
const Th = styled.th`text-align: left; padding: 8px; background: #f9fafb; border-bottom: 1px solid #e5e7eb; color: #6b7280; font-weight: 600;`;
const Td = styled.td`padding: 8px; border-bottom: 1px solid #f3f4f6; color: #374151;`;
const Badge = styled.span`
  font-size: 11px; padding: 2px 8px; border-radius: 10px; font-weight: 600;
  background: ${p => p.$type === 'approved' ? '#d1fae5' : '#fee2e2'};
  color: ${p => p.$type === 'approved' ? '#047857' : '#dc2626'};
`;
const Summary = styled.div`display: flex; gap: 16px; margin-bottom: 12px; flex-wrap: wrap;`;
const SummaryItem = styled.div`font-size: 13px; color: #6b7280;
  span { font-weight: 700; color: #111827; }
`;
const Bar = styled.div`display: flex; gap: 8px; margin-bottom: 12px; flex-wrap: wrap;`;
const BarItem = styled.div`
  font-size: 12px; padding: 4px 10px; border-radius: 6px; background: #f3f4f6; color: #374151;
  span { font-weight: 700; }
`;

function fmtDate(iso) { return iso ? new Date(iso).toLocaleDateString('ko-KR') : '-'; }

export default function SignupHistoryPanel({ refreshKey }) {
  const [period, setPeriod] = useState('30d');
  const [page, setPage] = useState(1);
  const { data, isLoading, error } = useMonitoringData(
    () => fetchSignupHistory(period, page, 20), [period, page, refreshKey]
  );

  const handlePeriod = (p) => { setPeriod(p); setPage(1); };

  return (
    <Panel title="회원 가입 이력" isLoading={isLoading} error={error}
      actions={<PeriodSelector value={period} onChange={handlePeriod} options={['7d','30d','90d']} />}>
      {data && <>
        <Summary>
          <SummaryItem>기간 내 가입: <span>{data.total_count}명</span></SummaryItem>
        </Summary>
        <Bar>
          {Object.entries(data.by_signup_type || {}).map(([k, v]) => (
            <BarItem key={k}>{k}: <span>{v}</span></BarItem>
          ))}
        </Bar>
        <div style={{ overflowX: 'auto' }}>
          <Table>
            <thead><tr>
              <Th>이름</Th><Th>이메일</Th><Th>연락처</Th><Th>가입경로</Th><Th>권한</Th><Th>상태</Th><Th>마지막 로그인</Th><Th>가입일</Th>
            </tr></thead>
            <tbody>
              {data.records?.map((r, i) => (
                <tr key={i}>
                  <Td>{r.name}</Td>
                  <Td>{r.email}</Td>
                  <Td>{r.phone_num}</Td>
                  <Td>{r.signup_type}</Td>
                  <Td>{r.client_type}</Td>
                  <Td><Badge $type={r.status}>{r.status === 'approved' ? '승인' : '미승인'}</Badge></Td>
                  <Td>{fmtDate(r.latest_login_at)}</Td>
                  <Td>{fmtDate(r.created_at)}</Td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <Pagination page={data.page} totalPages={data.total_pages} onChange={setPage} />
      </>}
    </Panel>
  );
}
